module.exports = __webpack_public_path__ + "img/prizeHide.b5d785bf.png";